<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="HiperDia"
            description="Consulta, aferição de PA e solicitação de hemoglobina"
            url="/doencas-cronicas"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Atendimento HiperDia',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
